module.exports = __webpack_public_path__ + "img/HubSpotCRM.4021c985.svg";